<template>
  <keep-alive>
    <router-view :key="$route.path"></router-view>
  </keep-alive>
</template>

<script>
export default {
  name: 'BrukerMain'
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/Bruker.vue